import React from "react";

export default props => <p className="body--text">{props.bodyText}</p>